module.exports = __webpack_public_path__ + "static/media/Aveny soffa 3-sits med divan brooksville soffbord miljö 2023 2.138788c4.jpg";